import { useEffect } from 'react';

export const useBlackBox = (onSuccess, onError) => {
  useEffect(() => {
    // basic configuration
    global.window.io_install_stm = false;
    // do not install Active X
    global.window.io_exclude_stm = 12;
    // do not run Active X
    global.window.io_install_flash = false;
    // do not install Flash
    global.window.io_enable_rip = true;
    // use callback to process blackbox as soon as it is done
    global.window.io_bb_callback = (bb, isComplete) => {
      // when done call the send function
      if (isComplete) {
        onSuccess(bb);
      }
    };

    // set up timer to give us a maximum wait time before giving up on waiting
    // for all of the data to be collected. At that point, just send what is
    // available
    const tId = setTimeout(() => {
      try {
        if (typeof ioGetBlackbox !== 'function') {
          return;
        }

        // oxlint-disable-next-line no-undef
        const bbInfo = ioGetBlackbox();
        onSuccess(bbInfo.blackbox);
      } catch (e) {
        // if we are done but got an error,
        // send an empty blackbox
        onError(e);
      }
      // set a maximum wait time of 3 second
    }, 3000);

    // load the library
    const script = global.document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://mpsnare.iesnare.com/snare.js';
    script.addEventListener('error', (e) => {
      if (typeof ioGetBlackbox !== 'function') {
        onError(e);
      }
    });

    global.document.head.appendChild(script);

    return () => {
      if (tId) {
        clearTimeout(tId);
      }

      delete global.window.io_install_stm;
      delete global.window.io_exclude_stm;
      delete global.window.io_install_flash;
      delete global.window.io_enable_rip;
      delete global.window.io_bb_callback;

      global.document.head.removeChild(script);
    };
  }, [onSuccess, onError]);
};
